<template>
  <div class="container" id="container-solicitantes">

    <b-modal no-close-on-backdrop centered ref="compareciente-modal" title="" hide-footer id="modalC" size="xl">
      <AgregaSolicitante :current-solicitante="currentCompareciente" :max-number-of-representantes="1"
        :ask-for-number="false" :proceso="4" @submit-form="putCompareciente" />
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog" hide-footer id="modal-confirm-dialog">
      <h4 class="text-center">¿Seguro que quiere remover el solicitante?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="deleteCompareciente">OK</b-button>
    </b-modal>

    <h4 class="cardD">Información de los Solicitantes</h4>
    <label class="fs-6 text-black-50 text-uppercase">Agregar solicitantes</label>

    <div class="mt-2">
      <label for="btn-add">Nuevo</label>
      <b-button variant="success" class="btn-fill spaceL" size="sm" @click="addCompareciente"
        :disabled="!canAddSolicitanteComputed" id="btn-add">
        +
      </b-button>
    </div>

    <div class="mt-2">
      <label>Ó</label>
    </div>

    <div class="mt-2">
      <div>
        <label for="select-comparecientes">Existente (solo aparecerán solicitantes de procesos concluídos)</label>
      </div>
      <div class="col-12">
        <select id="select-comparecientes" :disabled="!canAddSolicitanteComputed" class="custom-select"
          v-model="selectedSolicitante">
          <option v-for="option in comparecientesComboStore.getSelectOptions" :key="option.index" :value="option.index">
            {{ option.text }}
          </option>
        </select>
      </div>
    </div>

    <div v-if="cotejo.solicitantes.length > 0" class="mt-5">
      <b-table ref="table" hover :fields="fieldsCuadro" :items="cotejo.solicitantes">
        <template #cell(nombreCompleto)="{ item }">
          {{ displaytext(item) }}
        </template>
        <template #cell(acciones)="{ item }">
          <b-button v-if="!item.existente && !item.representante" variant="warning" size="sm" v-b-tooltip.hover
            title="Editar" class="editBtn" @click="editCompareciente(item)">
            <b-icon-pencil />
          </b-button>
          <b-button v-if="!item.representante" variant="danger" size="sm" v-b-tooltip.hover title="Eliminar"
            @click="predeleteComparreciente(item.id)">
            <b-icon-trash />
          </b-button>
        </template>
      </b-table>
    </div>

    <div class="mt-4">
      <div>
        <b-button class="btn-fill orange-btn bottom2" size="m" @click="checkComparecientes">Continuar</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import AgregaSolicitante from "@/components/AgregaSolicitante.vue";

import { useComparecientesComboStore, useUIStateStore } from '@/stores';
import { onMounted } from "vue";

export default {
  name: "SolicitantesCopiasCertificadas",

  components: {
    AgregaSolicitante
  },

  props: {
    cotejo: { type: Object }
  },

  computed: {
    fieldsCuadro() {
      return [
        { key: "index", label: "", class: "text-center" },
        { key: "nombreCompleto", label: "Nombre", class: "text-center", },
        { key: "persona", label: "Persona", class: "text-center" },
        // { key: "representadanombre", label: "Representa A:", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
      ];
    },

    canAddSolicitanteComputed() {
      return this.cotejo.solicitantes.length === 0;
    }
  },

  setup() {
    const uiState = useUIStateStore();
    const comparecientesComboStore = useComparecientesComboStore();

    onMounted(() => {
      comparecientesComboStore.fetchCombo();
    });

    return { comparecientes: comparecientesComboStore.comparecientes, comparecientesComboStore, uiState };
  },

  data() {
    return {
      selectedSolicitante: null,
      currentCompareciente: null,
      currentComparecienteId: null
    }
  },

  watch: {
    "selectedSolicitante": "selectedsolicitantes"
  },

  methods: {
    displaytext(item) {
      if (item.persona === "Física") {
        return `${item.nombre} ${item.paterno} ${item.materno || ""}`.trimEnd();
      }

      return item.denominacion_social;
    },

    showErrorToast(msg) {
      this.$toast.error(msg, {
        timeout: 4000,
        hideProgressBar: false,
        position: "top-right",
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    selectedsolicitantes(val, oldVal) {
      if (!this.selectedSolicitante) {
        return;
      }

      const index = val;
      const _solicitante = this.comparecientesComboStore.comparecientes[index - 1];
      const solicitanteToAdd = {
        id: _solicitante.id,
        cliente_id: _solicitante.cliente_id,
        nombre: _solicitante.nombre,
        paterno: _solicitante.paterno,
        materno: _solicitante.materno,
        denominacion_social: _solicitante.denominacion_social,
        persona: _solicitante.persona,
        actua_derecho_propio: true,
        existente: true,
      };

      _solicitante.index = this.cotejo.solicitantes.length + 1;

      this.cotejo.solicitantes.push(solicitanteToAdd);

      this.selectedSolicitante = null;
    },

    addCompareciente() {
      this.$refs["compareciente-modal"].show();
      this.currentCompareciente = {};
    },

    editCompareciente(item) {
      this.$refs["compareciente-modal"].show();
      this.currentCompareciente = item;
    },

    putCompareciente(solicitante) {
      this.currentCompareciente = Object.assign({}, solicitante);
      this.currentCompareciente.persona = this.currentCompareciente.tipoPersona;

      if (this.currentCompareciente.persona === 'Física') {
        this.currentCompareciente.nombreCompleto = this.currentCompareciente.nombre + ' ' + this.currentCompareciente.paterno
          + ' ' + (this.currentCompareciente.materno || "");

        this.currentCompareciente.representadanombre = "Por su propio derecho";

        if (!this.currentCompareciente.index) {
          this.currentCompareciente.index = this.cotejo.solicitantes.length + 1;

          this.cotejo.solicitantes.push(this.currentCompareciente);
        }
      } else {
        this.currentCompareciente.nombreCompleto = this.currentCompareciente.denominacion_social;

        if (!this.currentCompareciente.index) {
          this.currentCompareciente.index = this.cotejo.solicitantes.length + 1;

          this.cotejo.solicitantes.push(this.currentCompareciente);
        }
      }

      this.currentCompareciente = null;
      this.$refs["compareciente-modal"].hide();
    },

    predeleteComparreciente(id) {
      this.currentComparecienteId = id;
      this.$refs["modal-confirm-dialog"].show();
    },

    deleteCompareciente() {
      this.cotejo.solicitantes = [];
      this.currentCompareciente = {};

      this.$refs["modal-confirm-dialog"].hide();
    },

    checkComparecientes() {
      this.uiState.startLoading();
      this.isAnyCompareciente()
        // .then((continuar) => {
        //   if (continuar) {
        //     return this.everyMoralHasRepresentante();
        //   }
        // })
        // .then((continuar) => {
        //   if (continuar) {
        //     return this.everyFisicaHasTelefono();
        //   }
        // })
        .then((continuar) => {
          if (continuar) {
            this.$emit('allChecksPassed');
          }
        })
        .catch((error) => {
          console.log(error);
          this.showErrorToast('Sucedió un error. Intente más tarde')
        })
        .finally(() => this.uiState.stopLoading());
    },

    isAnyCompareciente() {
      return new Promise((resolve, reject) => {
        if (this.cotejo.solicitantes.length > 0) {
          resolve(true);
        } else {
          this.showErrorToast('Debe ingresar al menos 1 compareciente.');
          resolve(false);
        }
      });
    },

    everyMoralHasRepresentante() {
      return new Promise((resolve, reject) => {
        let moralAreCompleted = true;
        this.cotejo.solicitantes.forEach(solicitante => {
          if (solicitante.persona === 'Moral') {
            const representantes = this.countRepresentantes(solicitante.id);
            if (representantes == 0) {
              moralAreCompleted = false;
            }
          }
        });
        if (moralAreCompleted) {
          resolve(true);
        } else {
          this.showErrorToast('Cada persona moral debe tener al menos 1 representante.');
          resolve(false);
        }
      });
    },

    everyFisicaHasTelefono() {
      return new Promise((resolve, reject) => {
        let fisicaHasTelefono = true;

        this.cotejo.solicitantes.forEach(solicitante => {
          const esPersonaFisica = solicitante.persona === 'Física';
          const tieneTelefono = solicitante.hasOwnProperty('telefono');
          const telefonoValido = tieneTelefono &&
            solicitante.telefono.tipo &&
            solicitante.telefono.clave &&
            solicitante.telefono.numero;

          if (esPersonaFisica && (!tieneTelefono || !telefonoValido)) {
            fisicaHasTelefono = false;
          }
        });

        resolve(fisicaHasTelefono);

        if (!fisicaHasTelefono) {
          this.showErrorToast('Cada persona física debe tener 1 teléfono.');
        }
      });
    },

    countRepresentantes(solicitanteId) {
      let representantes = 0;

      this.cotejo.solicitantes.forEach(solicitante => {
        if (parseInt(solicitante.representada) == parseInt(solicitanteId)) {
          representantes += 1;
        }
      });

      return representantes;
    },
  }
}
</script>

<style scoped>
.container>>>.control-label {
  margin-left: 50px;
  width: 350px;
  position: absolute;
  vertical-align: middle;
}

.container>>>.custom-control-label {
  margin-left: 50px;
  position: absolute;
  margin-top: 40px;
}

.container>>>.control-label-top {
  margin-top: 0px !important;
  margin-left: 50px;
  text-align: left;
  width: 200px;
}

.container>>>.form-control {
  width: 80px;
  margin-left: 400px;
  position: absolute;
  vertical-align: middle;
}

.container>>>.form-check-sign {
  margin-top: 15px;
  position: absolute;
}

.check-label-pers {
  margin-left: 45px;
  margin-top: 20px;
  position: absolute;
}

.custom-select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 5px;
}
</style>
